<script lang="ts">
  interface Props {
    selected: boolean;
    disabled?: boolean;
    onclick: () => void;
    children: import('svelte').Snippet;
  }

  const { selected, disabled = false, onclick, children }: Props = $props();
</script>

<button
  type="button"
  class="chip"
  class:selected
  aria-pressed={selected}
  {disabled}
  {onclick}
>
  {@render children()}
</button>

<style>
  .chip {
    padding: var(--space-3) var(--space-4);
    border-radius: var(--radius-lg);
    border: 1px solid var(--c-line);
    background: transparent;
    color: var(--c-ink-muted);
    font-size: var(--step-0);
    text-align: left;
    transition: border-color 120ms var(--ease), color 120ms var(--ease);
  }

  /* Selection is a state, not a rank: the chip changes to show what the user
     chose, which is information, not encouragement. */
  .chip.selected {
    border-color: var(--c-accent);
    color: var(--c-ink);
  }

  .chip:disabled {
    opacity: 0.45;
  }
</style>
